import EventScaleData from './EventScaleData'
import EventOpenData from './EventOpenData'
import EventNumberData from './EventNumberData'
import ParticipantsData from './ParticipantsData'
import OutputParticipantsData from './OutputParticipantsData'
import EventMultipleData from './EventMultipleData'
import { useFirestoreGeneral } from '../../../firebase/useFirestore'
import OutputData from './OutputData'
import useSettings from '../../../hooks/Settings'
import { getDefaultColorPalette, resolveColor } from '../../../helpers/visualisationDefaults'

/**
 * @param {object} props
 * @param {import("../../../types/Firebase").EventFields} props.field
 * @param {string} props.selectedActivity - Activity ID
 * @param {string} [props.graphType]
 * @param {Array<string>} [props.colorPalette]
 * @param {string} [props.color]
 * @param {Object<string, string>} [props.colorOverrides]
 * @param {string} [props.startDate]
 * @param {string} [props.endDate]
 * @param {object|null} [props.templateActivityData] - Pre-fetched template data blob (from exportTemplateData).
 * @returns {JSX.Element}
 */
const EventDataType = ({
    field,
    color,
    startDate,
    endDate,
    selectedActivity,
    graphType = 'line',
    graphColor,
    colorPalette,
    colorOverrides,
    templateActivityData,
}) => {

    const settings = useSettings()
    const palette = colorPalette || getDefaultColorPalette(settings)

    const isTemplate = !!templateActivityData;

    // Firestore (skipped in template mode)
    const liveOutputs = useFirestoreGeneral("Outputs", "ActivityID", isTemplate ? '' : (selectedActivity || ''));

    const outputs = isTemplate
        ? (templateActivityData?.outputs?.outputs || []).filter(o => o.ActivityID === selectedActivity)
        : (liveOutputs || []).filter(o => !o.Deleted);

    // Template-mode pre-fetched outputs blob for OutputData
    const templateOutputData = isTemplate ? (templateActivityData?.outputs || null) : null;

    // Function to render chart type
     const renderData = () => {
        switch (field.Type) {
          case 'multiple-one':
          case 'multiple-multiple':
            return (
                <EventMultipleData
                field={field}
                color={color}
                graphColor={graphColor}
                colorPalette={palette}
                colorOverrides={colorOverrides}
                startDate={startDate}
                endDate={endDate}
                activityId={selectedActivity}
                templateActivityData={templateActivityData}
                />
            );
            case 'scale':
            return (
                <EventScaleData
                field={field}
                color={color}
                graphColor={graphColor}
                primaryColorOverride={color}
                startDate={startDate}
                endDate={endDate}
                activityId={selectedActivity}
                templateActivityData={templateActivityData}
                />
            );

          case 'number':
            return (
                <EventNumberData
                    field={field}
                    color={color}
                    graphColor={graphColor}
                    primaryColorOverride={color}
                    startDate={startDate}
                    endDate={endDate}
                    activityId={selectedActivity}
                    templateActivityData={templateActivityData}
                />
            );

          case 'open':
              return (
                  <EventOpenData
                    field={field}
                    color={color}
                    graphColor={graphColor}
                    startDate={startDate}
                    endDate={endDate}
                    activityId={selectedActivity}
                    templateActivityData={templateActivityData}
                  />
              );
            case 'participants':
              return (
                <ParticipantsData
                  field={field}
                  color={color}
                  graphColor={graphColor}
                  startDate={startDate}
                  endDate={endDate}
                  activityId={selectedActivity}
                  templateActivityData={templateActivityData}
                />
              );
            case 'date':
                return null;
            case 'outputs':
                return (
                  <div id='dashboard-output-detail-container' >
                      {outputs && outputs.length > 0 ? outputs.map((item, index) => (
                      <div key={item.ID} className='dashboard-output-detail-item-container'>

                          <OutputData
                          field={field}
                          outputId={item.ID}
                          graphType={graphType}
                          graphColor={graphColor}
                          color={resolveColor(item.ID, index, palette, colorOverrides)}
                          startDate={startDate}
                          endDate={endDate}
                          width={'100%'}
                          height={250}
                          templateOutputData={templateOutputData}
                          />
                      </div>
                      ))
                      : <div>Geen outputs gevonden voor deze activiteit</div>
                      }

                      {/* Deelnemers worden per output gekoppeld en staan in
                          Participants op de outputregistraties zelf. */}
                      {settings.personasOn === 'flex' && (
                        <OutputParticipantsData
                          field={field}
                          color={color}
                          startDate={startDate}
                          endDate={endDate}
                          templateActivityData={templateActivityData}
                        />
                      )}
                  </div>
                )
        }
    }

  return <>
    {renderData()}
    </>;
}

export default EventDataType